export const MultiLanguageUrl: Record<string, string> = {
  en: "en-US",
  fr: "fr-FR"
};

export const LanguageMapper: any = {
  en: "English",
  fr: "Français"
  // es: "Español",
  // cn: "中文",
  // sa: "العربية",
} as { [key: string]: string };
